import styled from 'styled-components'
import { Typography } from 'common/typography'
import Link from 'next/link'
import { SecondaryButton } from 'common/button'
import { useStudentsPodium } from 'querys/student-projects'
import LoadingState from 'common/loading-state'

const WeeklyPodiumStyled = styled.div`
  .podium {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    &-item {
      width: 100%;
      display: flex;
      gap: 0.5rem;
      align-items: center;
      img {
        border-radius: 50%;
      }
      p {
        flex: 1;
      }
    }
  }
  .podium-title {
    display: flex;
    justify-content: space-between;
  }
`

function WeeklyPodium() {
  const { data, isLoading } = useStudentsPodium({ defaultPeriod: 'weekly' })

  return (
    <WeeklyPodiumStyled className="progress-item">
      <div className="podium-title">
        <Typography as="h4" font="regularBold">
          Podium Semanal
        </Typography>
        <span>
          Puntos
        </span>
      </div>
      {isLoading ? (
        <LoadingState height={200} />
      ) : null}
      <ul className="podium">
        {data?.slice(0, 5).map(({ photo, username, full_name, score }) => (
          <li key={username}>
            <a href={`/estudiante/${username}`} className="podium-item" target="_blank" rel="noopener noreferrer">
              <img src={photo} width="32" height="32" alt={`Foto de perfil de ${full_name}`} />
              <Typography font="p2Bold">{full_name}</Typography>
              <Typography as="span" font="p2Bold" color="var(--turquoise)">{score}</Typography>
            </a>
          </li>
        ))}
      </ul>
      <Link href="/podium" passHref>
        <SecondaryButton fullWidth>
          Ver podio
        </SecondaryButton>
      </Link>
    </WeeklyPodiumStyled>
  )
}

export default WeeklyPodium
